import React from 'react'
import { twMerge } from 'tailwind-merge'

type LoadingProps = {
  className?: string
  children?: React.ReactNode
  title?: string
  size?: 'sm' | 'md' | 'lg'
  as?: 'div' | 'span'
  'aria-hidden'?: boolean
}

export default function Loading({
  size = 'sm',
  className,
  children,
  title,
  as: Tag = 'div',
  'aria-hidden': ariaHidden,
}: LoadingProps) {
  return (
    <Tag
      aria-hidden={ariaHidden}
      className={twMerge(
        'flex items-center',
        size === 'sm' && 'gap-2',
        size === 'md' && 'gap-3',
        size === 'lg' && 'gap-4',
        className,
      )}
    >
      <Tag
        title={title}
        className={twMerge(
          'text-primary inline-block shrink-0 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]',
          size === 'sm' && 'h-4 w-4',
          size === 'md' && 'h-6 w-6',
          size === 'lg' && 'h-8 w-8',
        )}
        role="progressbar"
      >
        <span className="sr-only">Lade Inhalte...</span>
      </Tag>
      {Boolean(React.Children.count(children)) && (
        <span
          className={twMerge(
            'text-text-secondary',
            size === 'sm' && 'text-xs',
            size === 'md' && 'text-sm',
          )}
        >
          {children}
        </span>
      )}
    </Tag>
  )
}
